import { Customer } from '../../../types/customer';
import { customerApi as api } from '../../api';

export async function updateCustomerAvatar(
  customerId: string,
  file: File,
): Promise<Customer[] | false> {
  try {
    const data = new FormData();
    data.append('file', file);

    const response = await api.patch<{ data: Customer[] }>(
      `/customer/updateAvatar/${customerId}`,
      data,
    );

    const customers: Customer[] = response.data.data;

    return customers;
  } catch (err) {
    console.error(
      `Ocorreu algum problema ao carregar os dados dos clientes, atualize a página e tente novamente 😕`,
      err,
    );
    return false;
  }
}
